import axios from "axios";
import React, { useContext, useEffect, useState } from "react";
import {
  DB_POSTFIX,
  apiFolderFileLinks,
  removeDoubleSlas,
} from "../../../utils";

import { Link } from "react-router-dom";

import { ServiceUrl } from "../../../utils/serviceUrl";

import { Col, Row } from "react-bootstrap";
import PsContext from "../../../context";
import TopMenuLgOffcanvas from "./topMenuLgOffcanvas";

const TopMenu = (props) => {
  const context = useContext(PsContext);
  const [menus, setMenus] = useState([]);
  const [fullMenus, setFullMenus] = useState([]);
  const [loader, setLoader] = useState(false);

  const [showFullMenus, setShowFullMenus] = useState(false);

  const [windowSize, setWindowSize] = useState(null);

  useEffect(() => {
    const handleResize = () => {
      // Perform actions on window resize
      //setWindowSize([window.innerWidth, window.innerHeight]);
      setWindowSize(window.innerWidth);
    };
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    setWindowSize(window.innerWidth);
  }, []);

  useEffect(() => {
    loadMenus();
  }, []);

  useEffect(() => {
    if (windowSize >= 1360) setMenus(fullMenus.slice(0, 9));
    else setMenus(fullMenus);
  }, [windowSize, fullMenus]);

  const loadMenus = () => {
    setLoader(true);
    axios.get(ServiceUrl.MENUS).then((res) => {
      if (res["data"].status == "1") {
        setFullMenus(res["data"].data);
      }
      setLoader(false);
    });
  };

  useEffect(() => {
    window.onscroll = function () {
      myFunction();
    };

    // Get the navbar
    var navbar = document.getElementById("ps__top__menu");

    // Get the offset position of the navbar
    var sticky = navbar.offsetTop;

    // Add the sticky class to the navbar when you reach its scroll position. Remove "sticky" when you leave the scroll position

    function myFunction() {
      if (window.scrollY >= (sticky || 150)) {
        navbar.classList.add("ps__top__menu__sticky");
      } else {
        navbar.classList.remove("ps__top__menu__sticky");
      }
    }
  }, []);

  const getSubMenu = (items) => {
    let rv = [];
    items.map((item, i) => {
      if (item.children && item.children.length > 0) {
        rv.push(
          <li className="dropdown">
            <a href="#">
              <span>{getMenuText(item)}</span>
              <i className="fa-solid fa-chevron-down"></i>
            </a>
            <ul>{getSubMenu(item.children)}</ul>
          </li>
        );
      } else {
        rv.push(
          <li>
            <Link className="" to={removeDoubleSlas("/" + item.menulink)}>
              {getMenuText(item)}
            </Link>
          </li>
        );
      }
    });
    return rv;
  };

  const getMenuText = (item) => {
    return isRegionalLanguage() && item.title_tam ? (
      <span className="text_unicode">{item.title_tam}</span>
    ) : (
      item.title
    );
  };

  const getMenu = (item) => {
    let rv = [];

    if (item.children && item.children.length > 0) {
      rv.push(
        <li className="dropdown">
          <a href="#" className="first_link">
            <span>{getMenuText(item)}</span>
            <i className="fa-solid fa-chevron-down"></i>
          </a>
          <ul>{getSubMenu(item.children)}</ul>
        </li>
      );
    } else {
      rv.push(
        <li>
          <Link
            className="nav-link  first_link"
            to={removeDoubleSlas("/" + item.menulink)}
          >
            {getMenuText(item)}
          </Link>
        </li>
      );
    }
    return rv;
  };

  const isRegionalLanguage = () => {
    return context.isRegionalLanguage();
  };

  const updateRegionalLang = (lang) => {
    context.setRegionalLanguage(lang);
  };

  return (
    <>
      <div className="py-1 ps__top__menu py-2" id="ps__top__menu">
        <nav id="navbar" className="navbar order-last order-lg-0 ">
          <ul className="top__menu ms-auto me-auto">
            {menus.map((item, i) => {
              return getMenu(item);
            })}
            {isRegionalLanguage() ? (
              <li className="lang-li-box">
                <a
                  onClick={(e) => updateRegionalLang("english")}
                  className="nav-link first_link"
                >
                  En
                </a>
              </li>
            ) : (
              <li className="lang-li-box">
                <a
                  className="nav-link first_link text_unicode"
                  onClick={(e) => updateRegionalLang("tamil")}
                >
                  தமிழ்
                </a>
              </li>
            )}
            {fullMenus.length > 9 && windowSize >= 1360 && (
              <li>
                <a
                  className="nav-link first_link"
                  onClick={(e) => setShowFullMenus(!showFullMenus)}
                >
                  <i
                    className="fa-solid fa-bars"
                    style={{ fontSize: "16px" }}
                  ></i>
                </a>
              </li>
            )}
          </ul>

          <div className="d-md-none d-sm-block">
            <Row>
              <Col xs={9}>
                <span class="logo me-auto ">
                  <Link to="/">
                    <img
                      src={apiFolderFileLinks(
                        context.settingValue("web_site_top_logo")
                      )}
                      style={{ width: "70%" }}
                    />
                  </Link>
                </span>
              </Col>
              <Col xs={3}>
                <div className="pt-3">
                  <a
                    className="nav-link text-white  pe-3"
                    onClick={(e) => setShowFullMenus(!showFullMenus)}
                  >
                    <i
                      className="fa-solid fa-bars"
                      style={{ fontSize: "25px" }}
                    ></i>
                  </a>
                </div>
              </Col>
            </Row>
          </div>
        </nav>
      </div>
      <TopMenuLgOffcanvas
        show={showFullMenus}
        onHideClick={(e) => setShowFullMenus(false)}
        menus={fullMenus}
      />
    </>
  );
};

export default TopMenu;
